//http://localhost:3100/kc#kidscrator/9i5_VAGeJ_iPki2Io6u7tA
import React, { useState, useEffect } from 'react';
import DataProvider from "./lib/dataprovider"
import './App.css';
import { useLocation } from "react-router-dom"
import { setGlobalData } from "./lib/globalData"
import Shop from "./pages/shop"
import Creator from "./pages/creator"
import Biblio from "./pages/biblio"
import Register from "./pages/register"
import Login from "./pages/login"
import Basket from "./pages/basket"
import Invoice from "./pages/invoice"
import Profil from "./pages/profil"
import License from "./pages/license"
import Kidscreator from "./pages/kidscreator"

const App = props => {
  var hostname = window.location.hostname;
  var is_dev = false;
  var is_test = false;
  var host = '';
  debugger;
  if (hostname.indexOf('bern.soundolino')>-1) {
    host = 'bern.';
  }
  if (hostname.indexOf('dev.soundolino')>-1 || hostname==='localhost') {
    is_dev = true;
    host = hostname.indexOf('bern.dev.soundolino')>-1?'bern.dev.':'dev.';
  }
  else if (hostname.indexOf('test.soundolino')>-1 ) {
    is_test = true;
    host = 'test.';
  }

  const [staticel, setStaticel] = useState([]);
  const [userinfo, setUserInfo] = useState(false);
  const [token, setToken] = useState(false);
  const [dataprovider] = useState(new DataProvider());

  const location = useLocation().hash;
  const locParts = location.split('/');
  const ep = locParts[0].split('?');

  useEffect(() => {
    var newtoken = false;
    var hash = window.location.hash.substr(1); 
    if (ep[0]==='#kidscreator')  { // Debug KidsCreator
      window.kidscreator = true;
      hash = locParts[1];
    }
    if (window.kidscreator) {
      newtoken = 'kidscreator|' + hash;
      setGlobalData({token: newtoken});
      setToken(newtoken);
      console.log(['newtoken', newtoken])
    }
    if (token && !newtoken) {
      console.log('app.js:'+token);
      dataprovider.getList('staticel', {}, setStaticel);
      dataprovider.getList('token', {}, setUserInfo);
    }
    else {
      console.log('No token');
      dataprovider.init('api.'+host+'soundolino.ch', setToken);
    }
  }, [token]);
  
  const updateBasket = (data) => {
    if (window.updateCart) {
      var anz = 0;
      for (var i = 0; i<data.length; i++) {
        anz += data[i].count;
      }
      window.updateCart(anz);
    }
  }
  useEffect(() => {
    if (userinfo.id) {
      dataprovider.getList('basket', {}, updateBasket);
    }
  }, [userinfo]);
  

  const setUserField = (field, value) => {
    const ui = {...userinfo, [field]:value};
    setUserInfo(ui);
  }

  if (!token) {
    return null;
  }
  
  const inject = {dataprovider, is_dev, staticel, userinfo, setUserField, setToken, id:locParts[1], params:ep[1]};
  
  if (window.kidscreator===true) {
    return <Kidscreator {...inject} />
  }
  
  switch (ep[0]) {
    case '#creator': return <Creator {...inject} />
    case '#bibliothek': return <Biblio {...inject}  />
    case '#register': return <Register {...inject} />
    case '#login': return <Login {...inject} />
    case '#basket': return <Basket {...inject} />
    case '#invoice': return <Invoice {...inject} />
    case '#profil': return <Profil {...inject} />
    case '#license': return <License {...inject} />
    case '#kidscreator': return <Kidscreator {...inject} />
    default: return <Shop {...inject} />
  }
}

export default App;
